<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="normal"
      notFooterPadding
  >
    <template #header>
      {{isMeaningful(item) ? '填写' : '填写'}}CaseID
      <!-- <span class="input-case-title">{{msku}}</span> -->
    </template>
    <template #content>
      <template v-if="!isMeaningful(item)">
        <gj-alert
            style="margin-bottom: 20px"
            type="warning"
            show-icon
            border
        >
          请确认已在对应店铺/站点后台申请Case后录入实际索赔信息；如果后台没有申请，请输入0。
        </gj-alert>
      </template>
      <el-form
          :model="form"
          :label-position="'right'"
          label-width="120px"
          ref="form"
      >
        <el-form-item
            prop="caseId"
            label="Case ID"
            :rules="[
              {required: true, message: '请输入Case ID', trigger: ['blur', 'change'] },
              $gjReRule(RE.pt, '请输入正确的Case ID')
            ]"
        >
          <gj-input
              v-model="form.caseId"

              width="340px"></gj-input>
        </el-form-item>
        <el-form-item
            prop="estimateDamageQuantity"
            label="库存损坏索赔数量"
            :rules="[
              {required: false, message: '库存损坏索赔数量', trigger: ['blur', 'change'] },
              $gjReRule(RE.pt0, '请输入0或正整数')
            ]"
        >
          <gj-input
              v-model="form.estimateDamageQuantity"

              width="340px"></gj-input>
        </el-form-item>
        <el-form-item
            prop="estimateLostQuantity"
            label="库存丢失索赔数量"
            :rules="[
              {required: false, message: '库存丢失索赔数量', trigger: ['blur', 'change'] },
              $gjReRule(RE.pt0, '请输入0或正整数')
            ]"
        >
          <gj-input
              v-model="form.estimateLostQuantity"

              width="340px"></gj-input>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <template>
        <gj-button @click="confirm" type="primary" :loading="loading">确定</gj-button>
      </template>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, isMeaningfulMixin, modalMixIn} from "@/minxins";
  import {isMeaningful} from "@/utils/common";
  import {updateStorageClaim} from "@/api/sale";

  export default {
    name: "claim-input-case",
    mixins: [modalMixIn, formRuleMixin, isMeaningfulMixin],
    props: {
      id: null,
      msku: null,
      item: null,
    },
    created() {
      this.form.id = this.id;
      if (isMeaningful(this.item)) {
        this.form.caseId = this.item.caseId;
        this.form.estimateDamageQuantity = this.item.estimateDamageQuantity;
        this.form.estimateLostQuantity = this.item.estimateLostQuantity;
      }
    },
    data() {
      return {
        loading: false,
        form: {
          id: null,
          caseId: null,
          estimateDamageQuantity: null,
          estimateLostQuantity: null,
        }
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.loading = true;
          updateStorageClaim(this.form)
            .then((res) => {
              if (res.code !== 0) {
                  this.$gjMessage.error(res.msg);
              } else {
                this.$gjMessage.success('操作成功！请在已索赔数据中查看索赔结果');
                this.$emit('after');
              }
            }).complete(() => this.loading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .input-case-title {
    font-size: 12px;
    color: #666;
    margin-left: 12px;
  }
  ///deep/ .el-form-item{
  //  &:last-child{
  //    margin-bottom: 0;
  //  }
  //}
</style>
